import VerifiedDropdown from './VerifiedDropdown'

export default VerifiedDropdown
export { DEFAULT_TITLE as VERIFIED_TITLE } from './VerifiedDropdown'
